import { defineStore } from 'pinia'

import type { IFetchApiFetchChecklistList } from '~/portal/api'
import {
	createDocumentsChecklistItem,
	fetchApiChangeChecklistVersion,
	fetchApiDeleteChecklistItem,
	fetchApiFetchChecklistList,
	fetchApiGetChecklistAvailableVersions,
	fetchGetChecklistItem
} from '~/portal/api'
import type { ICPDocumentsChecklistStoreTypes } from '~/portal/stores'

export const useDocumentsChecklistStore = defineStore(
	'documentsChecklistStore',
	{
		state: (): ICPDocumentsChecklistStoreTypes => ({
			checklist: {},
			checklistItem: {},
			isInternal: false,
			checklistVersions: []
		}),
		actions: {
			resetChecklist() {
				this.checklist = {}
				this.checklistItem = {}
				this.isInternal = false
				this.checklistVersions = []
			},
			async fetchChecklistList(payload: IFetchApiFetchChecklistList) {
				const response = await fetchApiFetchChecklistList(payload)
				if (response) {
					this.checklist = response.results[0]
					this.isInternal = payload.phase === 'INTERNAL'
				}
			},
			async fetchChecklistAvailableVersions(payload: {
				token: string
				projectId: number
				checklistId: number
				page?: number
				pageSize?: number
			}) {
				const response = await fetchApiGetChecklistAvailableVersions({
					token: payload.token,
					projectId: payload.projectId,
					checklistId: payload.checklistId,
					page: payload.page,
					page_size: payload.pageSize
				})
				if (response) {
					this.checklistVersions = response.results
				}
			},
			async changeChecklistVersion(payload: {
				token: string
				projectId: number
				checklistId: number
				versionId: number
				phase: string
			}) {
				const response = await fetchApiChangeChecklistVersion({
					token: payload.token,
					projectId: payload.projectId,
					checklistId: payload.checklistId,
					newChecklistVersionId: payload.versionId
				})
				if (response) {
					await this.fetchChecklistList({
						token: payload.token,
						projectId: payload.projectId,
						phase: payload.phase
					})
				}
			},
			async deleteChecklistItem(payload: {
				token: string
				checklistItemId: number
				checklistId?: number
				isCustom?: boolean
			}) {
				if (!payload.checklistId || !payload.token) return

				const response = await fetchApiDeleteChecklistItem({
					token: payload.token,
					checklistItemId: payload.checklistItemId,
					checklistId: payload.checklistId,
					isCustom: payload.isCustom
				})

				if (response) {
					this.checklist.items = this.checklist.items?.filter(
						(item: any) => item.id !== payload.checklistItemId
					)
				}
			},
			async createChecklistItem(payload: {
				token: string
				projectId: number
				isCustom?: boolean
				checklistId?: number
				phase: string
				data: {
					name: string
					description: string
				}
			}) {
				if (!payload.checklistId) return

				const response = await createDocumentsChecklistItem({
					...payload,
					checklistId: payload.checklistId
				})

				if (response) {
					await this.fetchChecklistList({
						token: payload.token,
						projectId: payload.projectId,
						phase: payload.phase
					})
				}
			},
			async fetchChecklistItem(payload: {
				token: string
				checklistItemId: number
				checklistId: number
				projectId?: number
			}) {
				const response = await fetchGetChecklistItem(payload)
				if (response) {
					this.checklistItem = response
				}
			}
		}
	}
)
